import React from 'react'
import { AuthState, AuthStateConstructorArgs } from './AuthState'
import { LoginContext } from '../LoginContext'

type WithAuthStateContextProps = {
  args: AuthStateConstructorArgs
}

export const WithAuthStateContext: React.FC<WithAuthStateContextProps> = ({
  children,
  args
}) => {
  const ctx = React.useMemo(() => {
    return new AuthState(args)
  }, [])

  return <LoginContext.Provider value={ctx}>{children}</LoginContext.Provider>
}
